module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAAuCAYAAABnNToWAAAABGdBTUEAALGPC/xhBQAAAH1JREFUaAXt17ENgDAMBECHkrUQDQOxAxtRwFx0iAlcUeCgS2krinNfOcIhQOCNQMsuz8e+3nFvWf+zeovrnJYxe3/IGr3WfajX5MxNgAABAgQIECBQX8A+VD0j+1D1hMxHgAABAgQIECDQr4B9qHp29qHqCZmPAAEC/xZ4AC43FRZhc/yoAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./assets/Layout/hamburger-teal.png
// module id = ./assets/Layout/hamburger-teal.png
// module chunks = 168707334958949